import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import TwoColumnLayout from "layout/TwoColumnLayout";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import ListTemplate from "components/ListTemplate";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import VisibilityFilter from "components/filters/Filters/VisibilityFilter";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";


const CostCenterList = () => {
  const viewModel = useLoaderData<server.viewmodel.CostCenterListFrontModel>();

  const { colors } = serverReference.constants;

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet="costCenter_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={window.CoreApi.CostCenter.ListCostCenter}
        getId={item => item.costCenterId}
        layout={{
          type: "card",
          sections: {
            renderTitle: costCenter => <div>
              <div>
                <a href={routes.costCenter_Edit(costCenter.costCenterId).absolute} className="table-main-link">{costCenter.title}</a>
              </div>
            </div>,
            renderBody: costCenter => <div>
              <div>
                {costCenter.internalId}
              </div>

              <div className="flex gap-small">
                <div>
                  <i className="icon-circle" style={{ color: costCenter.visible ? colors.green : colors.red }} />
                </div>

                {costCenter.visible ? RESX.GeneralLabels.Visible : RESX.GeneralLabels.NotVisible}
              </div>
            </div>,
            renderFooter: () => <></>,
            hideFooter: () => true,
            hideTitle: () => false

          }
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Keyword} />
          <VisibilityFilter />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
        onEdit={(item) => window.location.href = routes.costCenter_Edit(item.costCenterId).absolute}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>;
};

export default CostCenterList;